/* eslint no-process-env:0 */
import appConfig from '../../appConfig/AppConfig';
import api from './api';

const conf = appConfig();

/**
 * @param  {string}  query  template graphql query
 * @param  {string}  type   'mutation' or 'query'
 * @return {promise} returns a promise of a result of the post to the gateway
 */
export default function gatewayFetch(query, type) {
  const isClient = typeof window !== 'undefined' && window.document;
  const gateway = isClient ? conf.apiGateway : conf.internalApiGateway;
  const operationName =
    type === 'query' ? 'LegacyApiQuery' : 'LegacyApiMutation';
  const requestPayload = {
    query,
    operationName,
    variables: null,
  };

  return api.post(
    gateway,
    requestPayload,
    conf.gatewayFetch.post.options,
    isClient
  );
}



// WEBPACK FOOTER //
// ./src/appModules/utilities/gatewayFetch.js